import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  static targets = [
    'expandable',
    'dots'
  ]

  connect() {
    if (this.hasExpandableTarget) {
      this.dotsTarget.classList.remove('hidden')
    }
  }

  toggleExpand() {
    this.expandableTarget.classList.toggle('expanded')
  }
}
